import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Assignment, Visibility } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import CustomerModal from './CustomerModal';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { LayerProvider } from 'contexts/layerContext';
import { Box } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'Nuevo', accessor: 'new', width: 80 },
  // { Header: 'Total Filas', accessor: 'totalRows', width: 150 },
  { Header: 'Vendedor', accessor: 'SlpName', width: 300 },
  { Header: 'Hora envío', accessor: 'created_at', width: 150 },
  { Header: 'Nombre socio', accessor: 'bPartner', width: 350 },
  { Header: 'Latitud', accessor: 'latitude', width: 150 },
  { Header: 'Longitud', accessor: 'longitude', width: 150 },
  // { Header: 'N° Documento', accessor: 'documentNum', width: 150 },
  { Header: 'Observación', accessor: 'observation', width: 200 },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Customer(props) {
  const classes = useStyles();

  const [customers, setCustomers] = useState([]);
  const [customerId, setCustomerId] = useState(null);
  const [zoneId, setZoneId] = useState();

  const [dataLoading, setDataLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  async function getCustomers(search) {
    if (search === undefined) {
      search = { state: 'X' };
    }

    if (search) {
      search = {
        base_seller_id: search.base_seller_id,
        base_zone_id: search.base_zone_id,
        start_date: search.start_date,
        end_date: search.end_date,
        state: 'X',
      };
    }

    for (var clave in search) {
      if (search[clave] == null) {
        delete search[clave]; //eliminamos solo las claves vacias
      }
    }
    setDataLoading(true);
    let response = await wsFindBy('ordm/customer', search);
    setDataLoading(false);
    if (response.success) setCustomers(response.data);
  }

  function deleteCustomer(customerId) {
    let findIndex = customers.findIndex((customer) => customer.id === customerId);
    if (findIndex !== -1) {
      let newCustomers = [...customers];
      newCustomers.splice(findIndex, 1);
      setCustomers(newCustomers);
    }
  }

  return (
    <LayerProvider>
      <CustomerModal
        open={open}
        setOpen={setOpen}
        deleteCustomer={deleteCustomer}
        customerId={customerId}
        zoneId={zoneId}
      />
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color={props.themeContext.buttonColor}>
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Listado de cambios Clientes {dataLoading && <LoadingSpinner />}</h4>
            </CardHeader>
            <CardBody>
              <FilterCustom getFilter={getCustomers} dateRange zone seller />
              <ReactTable
                excelName="Clientes"
                defaultWidth={1700}
                columns={columns}
                data={customers.map((customer, i) => {
                  return {
                    num: (
                      <Box display="flex" alignItems="center">
                        {i + 1}
                        <AllowedGuard permission={ConstantPermissions.ORDM_CUSTOMERS_SHOW}>
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColor}
                            onClick={() => {
                              handleClickOpen();
                              setCustomerId(customer.id);
                              setZoneId(customer.seller_zone_id);
                            }}
                          >
                            <Visibility />
                          </Button>
                        </AllowedGuard>
                      </Box>
                    ),

                    new: customer.new == 'Y' ? 'Si' : 'No',
                    SlpName: customer.SlpName,
                    created_at: customer.created_at,
                    bPartner: customer.business_name,
                    latitude: customer.latitude,
                    longitude: customer.longitude,
                    observation: customer.observations,
                    state: customer.state === 'A' ? 'Activo' : 'Inactivo',
                    actions: '',
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </LayerProvider>
  );
});
